import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { KeywordCategory } from 'container/SEOTools/types'

type Parameters = {
  companyId: string
  category: string
  domainId?: string
}

const createCategory = async ({
  companyId,
  domainId,
  category,
}: Parameters): Promise<{
  status: 'error' | 'success'
  data: KeywordCategory
  error?: string
}> => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/keyword-discovery/domains/${domainId}/categories`
  const response = await axios.post(url, {
    category,
  })

  return {
    status: 'success',
    data: extract.data(response).data,
  }
}

export const useCreateCategory = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (params: Parameters) => createCategory(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries(['related-categories'])
      await queryClient.invalidateQueries(['keyword-categories'])
    },
  })
}
